import React from "react";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material/";
import styles from "./styles";
import { strings } from "../../i18n";

const Loading = ({ loadingText }) => {
    return (
        <Backdrop
            sx={(theme) => ({
                color: "#fff",
                zIndex: 9999 // theme.zIndex.drawer + 1
            })}
            open={true}
        >
            <Box sx={styles.spinner}>
                <Box sx={styles.loaderRoller}>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </Box>
                <Typography>
                    {loadingText
                        ? `${strings(loadingText)}...`
                        : `${strings("loading")}...`}
                </Typography>
            </Box>
            {/* <CircularProgress /> */}
            {/* <Typography component="div" sx={styles.textContainer}>
                {loadingText
                    ? `${strings(loadingText)}...`
                    : `${strings("loading")}...`}
            </Typography> */}
        </Backdrop>
    );
};
{
    /* </Box> </Box> */
}
export default Loading;
